import {useMutation} from "@tanstack/react-query";

import {removeSupplierFunctionMutationOptions} from "./remove-supplier-function.mutation-options";

export function useRemoveSupplierFunction(supplierId: string) {
  return useMutation(removeSupplierFunctionMutationOptions(supplierId));
}
